import React from "react";
import { Col, Row } from "react-bootstrap";
import {
    SiLeetcode,
    SiCodechef,
    SiHackerrank,
} from "react-icons/si";

function Codingprofiles() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px", cursor:'alias' }}>
      <Col xs={4} md={2} className="tech-icons" onClick={() => window.open('https://www.hackerrank.com/rushabhpanbude', '_blank')}>
        <SiHackerrank/>
      </Col>
      <Col xs={4} md={2} className="tech-icons" onClick={() => window.open('https://leetcode.com/rushabhpanbude/', '_blank')}>
        <SiLeetcode/>
      </Col>
      <Col xs={4} md={2} className="tech-icons" onClick={() => window.open('https://www.codechef.com/users/rushabhpanbude', '_blank')}>
        <SiCodechef/>
      </Col>
    </Row>
  );
}

export default Codingprofiles;
